import { useCallback, useRef } from "react";
import useTrackerContext from "../useTrackerContext.js";
import { FLIGHT_DEAL_HIGHLIGHT_REASON, FLIGHT_DEAL_LANDING_PAGE_CURRENCY_PARAM, FLIGHT_DEAL_LANDING_PAGE_PRICE_PARAM, FLIGHT_DEAL_OFFER_AGE_MINUTES_PARAM, isFlightDealUseCaseSearch } from "../../utils/flight-deals.js";
const ACTION_NAME = "flights__landing_page_offer_price_accuracy";
const ACTION_VERSION = "4.0.0";
const getFlightOfferKey = (flight) => flight.flightKey || flight.offerKeyToHighlight;
const getNumberParam = (params, key) => {
    const value = params.get(key);
    if (value === null || value === "")
        return undefined;
    const parsed = Number(value);
    return Number.isFinite(parsed) ? parsed : undefined;
};
const isDealsLandingHighlightedOffer = (flight) => !!flight.highlightInfo?.highlight && flight.highlightInfo.reason === FLIGHT_DEAL_HIGHLIGHT_REASON;
const getHighlightedDealOffer = (flightOffers, highlightedOfferKey) => flightOffers.find((flight) => {
    return getFlightOfferKey(flight) === highlightedOfferKey && isDealsLandingHighlightedOffer(flight);
});
export const getLandingPageOfferPriceAccuracyContent = (searchResults, search) => {
    if (!isFlightDealUseCaseSearch(search))
        return undefined;
    const params = new URLSearchParams(search);
    const highlightedOfferKey = params.get("offerKeyToHighlight");
    const priceOnLandingPage = getNumberParam(params, FLIGHT_DEAL_LANDING_PAGE_PRICE_PARAM);
    const offerAgeMinutes = getNumberParam(params, FLIGHT_DEAL_OFFER_AGE_MINUTES_PARAM) ?? 0;
    const origin = params.get("from");
    const destination = params.get("to");
    const currency = params.get(FLIGHT_DEAL_LANDING_PAGE_CURRENCY_PARAM);
    if (!highlightedOfferKey || priceOnLandingPage === undefined || !origin || !destination || !currency) {
        return undefined;
    }
    const highlightedOffer = getHighlightedDealOffer(searchResults.flightOffers, highlightedOfferKey);
    const discountedPerTravellerPrice = highlightedOffer?.travellerPrices[0]?.travellerPriceBreakdown.total;
    if (!highlightedOffer?.token ||
        !discountedPerTravellerPrice ||
        discountedPerTravellerPrice.currencyCode !== currency) {
        return undefined;
    }
    return {
        price_on_landing_page: priceOnLandingPage,
        offer_age_minutes: offerAgeMinutes,
        origin,
        destination,
        currency,
        flight_offer_token: highlightedOffer.token,
        price_difference: discountedPerTravellerPrice.units - priceOnLandingPage
    };
};
export default function useLandingPageOfferPriceAccuracyEvent() {
    const { trackExternal } = useTrackerContext();
    const hasTrackedRef = useRef(false);
    return useCallback((searchResults, search) => {
        if (hasTrackedRef.current)
            return;
        const content = getLandingPageOfferPriceAccuracyContent(searchResults, search);
        if (!content)
            return;
        hasTrackedRef.current = true;
        trackExternal({
            type: "c360",
            args: [
                {
                    action_name: ACTION_NAME,
                    action_version: ACTION_VERSION,
                    content
                }
            ]
        });
    }, [trackExternal]);
}
